export enum ContactMontageDateEnum {
  LessThan3Months = 'lessThan3Months',
  Between3And6Months = 'between3And6Months',
  Between6And12Months = 'between6And12Months',
  MoreThan12Months = 'moreThan12Months',
  NotPlannedYet = 'notPlannedYet',
}
